import React, { useContext, useEffect, useState } from 'react'
import Title from 'antd/es/typography/Title';
import { Button, InputNumber, message, Select, Table } from 'antd';
import { API } from '../../Axios/Axios';
import { assignPoiVerification, fetchInvestmentCycles, fetchPOIDeclarationData, fetchPOISubmissionData, fetchUserList, fetchVerificationData } from '../../Helpers/APIEndpoints/Endpoints';
import { Pie, Column } from '@ant-design/charts';
import FormControl from '../../Components/DynamicFieldRenderer/FormStructure/FormStructure';
import FormTable from '../../Components/DynamicTable/FormTable';
import { useAuthStore } from '../../AuthStore/AuthStore';
import { FormSelect } from '../../Components/FormSelect';
import { FormInput } from '../../Components/FormInputs/FormInputs';
import { useNavigate } from 'react-router-dom';
import { LoaderContext } from '../../Helpers/Context/Context';


interface POIDeclarationDataType {
  TotalEmployeeCount: number;
  SubmittedDeclaration: number;
  NotSubmittedDeclaration: number;
}

interface InvestmentCycleDataType{
  value:number;
  label:string;
  isCurrentCycle:boolean;
  startDate:Date;
  endDate:Date;
}

interface DropDownType{
  value:number;
  label:string;
}

interface POISubmissionDataType{
  InvestmentCycleName: string;
  TotalEmployeeCount:number;
  Submitted:number;
  NotSubmitted:number;
  Accepted:number;
  Rejected:number;
  PartiallyAccepted:number;
  PendingVerification:number;
  Unassigned:number;
}

interface POIVerificationDataType{
  Role:string,
  Name:string,
  TotalAssigned:number,
  TotalAccepted:number,
  TotalRejected:number,
  TotalPartiallyAccepted:number,
  TotalPendingVerification:number
}

const VerificationPOI = ({widthSize = "large"}) => {

  const widthPercentage: string = (() => {
    switch (widthSize.toLowerCase()) {
      case "medium":
        return "75%";
      case "small":
        return "50%";
      default:
        return "100%";
    }
  })();
  const {currentFinancialYearId,userId} = useAuthStore()
  const [verifierCycle,setVerifierCycle] = useState(null)
  const [usrRoleListArr,setUsrRoleList] = useState<any>([]);
  const { currentRoleId, currentuserroleList } = useAuthStore();
  const [POIDeclarationColumns, setPOIDeclarationColumns] = useState([
    {
      title: "Total Employee Count",
      key: "Total Employee Count",
      dataIndex: "TotalEmployeeCount",
      //fixed: "right",
      width: 100,
      align: 'center',
    },
    {
      title: "Submitted Declaration",
      key: 'Submitted Declaration',
      dataIndex: "SubmittedDeclaration",
      //fixed: "right",
      width: 100,
      align: 'center',
    },
    {
      title: "Not Submitted Declaration",
      key: 'Not Submitted Declaration',
      dataIndex: "NotSubmittedDeclaration",
      //fixed: "right",
      width: 100,
      align: 'center',
    }
  ]);


  const [POISubmissionColumns, setPOISubmissionColumns] = useState([
    {
      title: "Investment Cycle",
      key: "Investment Cycle",
      dataIndex: "InvestmentCycle",
      //fixed: "right",
      width: 50,
      align: 'left',
    },
    {
      title: "Total Employee Count",
      key: "Total Employee Count",
      dataIndex: "TotalEmployeeCount",
      //fixed: "right",
      width: 50,
      align: 'center',
    },
    {
      title: "Submitted",
      key: 'Submitted',
      dataIndex: "Submitted",
      //fixed: "right",
      width: 50,
      align: 'center',
    },
    {
      title: "Not Submitted",
      key: 'Not Submitted',
      dataIndex: "NotSubmitted",
      //fixed: "right",
      width: 50,
      align: 'center',
    },
    {
      title: "Accepted",
      key: 'Accepted',
      dataIndex: "Accepted",
      //fixed: "right",
      width: 50,
      align: 'center',
    },
    {
      title: "Rejected",
      key: 'Rejected',
      dataIndex: "Rejected",
      //fixed: "right",
      width: 50,
      align: 'center',
    },
    {
      title: "Partially Accepted",
      key: 'Partially Accepted',
      dataIndex: "PartiallyAccepted",
      //fixed: "right",
      width: 50,
      align: 'center',
    },
    {
      title: "Pending Verification",
      key: 'Pending Verification',
      dataIndex: "PendingVerification",
      //fixed: "right",
      width: 50,
      align: 'center',
    },
    {
      title: "Unassigned",
      key: 'Unassigned',
      dataIndex: "Unassigned",
      //fixed: "right",
      width: 50,
      align: 'center',
    }
  ]);

  const [POIVerifierStatusColumn,setPOIVerifierStatusColumn] = useState([
    {
      title: "Role",
      key: "Role",
      dataIndex: "Role",
      //fixed: "right",
      width: 100,
      align: 'center',
    },
    {
      title: "Name",
      key: "Name",
      dataIndex: "Name",
      //fixed: "right",
      width: 100,
      align: 'center',
    },
    {
      title: "Total Assigned",
      key: 'TotalAssigned',
      dataIndex: "TotalAssigned",
      //fixed: "right",
      width: 100,
      align: 'center',
    },
    {
      title: "Total Accepted",
      key: 'TotalAccepted',
      dataIndex: "TotalAccepted",
      //fixed: "right",
      width: 100,
      align: 'center',
    },
    {
      title: "Total Rejected",
      key: 'TotalRejected',
      dataIndex: "TotalRejected",
      //fixed: "right",
      width: 100,
      align: 'center',
    },
    {
      title: "Total Partially Accepted",
      key: 'TotalPartiallyAccepted',
      dataIndex: "TotalPartiallyAccepted",
      //fixed: "right",
      width: 100,
      align: 'center',
    },
    {
      title: "Total Pending Verification",
      key: 'TotalPendingVerification',
      dataIndex: "TotalPendingVerification",
      //fixed: "right",
      width: 100,
      align: 'center',
    }
  ])

  const [POIDeclarationData, setPOIDeclarationData] = useState<POIDeclarationDataType[]>([]);
  const [POISubmissionData, setPOISubmissionData] = useState<POISubmissionDataType[]>([]);
  const [POIVerificationDashBoardData,setVerificationDashboardData] = useState<POIVerificationDataType[]>([]);
  const [columnChart, setColumnChart] = useState<any>(null);
  const [currentGraphIndex,setCurrentGraphIndex]= useState(null);
  const [InvestmentCyles,setInvestmentCyles] = useState<InvestmentCycleDataType[]>([])
  const [userListOption,setUserListOption] = useState<DropDownType[]>([])
  const [selectedUser,setSelectedUser] = useState(null);
  const [count,setCount] = useState(null);
  const [VerifierStaus,setVerifierStaus] = useState(null);
  const [counterStatus,setCounterStatus] = useState(null);
  const [userError, setUserError] = useState("");
  const [countError, setCountError] = useState("");
  const {showLoader, hideLoader} = useContext(LoaderContext);
  const navigate = useNavigate();
  useEffect(() => {
   
    getPOIDeclarationData()
  }, [])

   const getPOIDeclarationData = async () => {
      
      let responsePOIDeclarationData = await API.post(fetchPOIDeclarationData, { CurrentFyId: currentFinancialYearId })
      if (responsePOIDeclarationData?.data?.data) {
        const declarationPOItableData: POIDeclarationDataType[] = responsePOIDeclarationData.data.data.map((item: any) => ({
          TotalEmployeeCount: item.totalEmployeeCount,
          SubmittedDeclaration: item.submittedDeclaration,
          NotSubmittedDeclaration: item.notSubmittedDeclaration
        }));
        
        setPOIDeclarationData(declarationPOItableData);
      }
      
      let responseInvestmentCycles = await API.post(fetchInvestmentCycles,{ CurrentFyId: currentFinancialYearId })
      
      if(responseInvestmentCycles?.data?.data){
        setInvestmentCyles(responseInvestmentCycles?.data?.data)
      }

      let responsePOISubmissionData = await API.post(fetchPOISubmissionData, { CurrentFyId: currentFinancialYearId })
      
      if(responsePOISubmissionData?.data?.data){
        const submissionPOItableData: POISubmissionDataType[] = responsePOISubmissionData.data.data.map((item:any)=>({
          InvestmentCycle: item.investmentCycleName,
          TotalEmployeeCount:item.totalEmployeeCount,
          Submitted:item.submittedCount,
          NotSubmitted:item.notSubmittedCount,
          Accepted:item.acceptedCount,
          Rejected:item.rejectedCount,
          PartiallyAccepted:item.partiallyAcceptedCount,
          PendingVerification:item.pendingVerificationCount,
          Unassigned:item.unassignedCount,
        }));
        
        setPOISubmissionData(submissionPOItableData)
      }

      let responseUserData = await API.post(fetchUserList,{Id:userId}) 
      
      if(responseUserData?.data?.data){
        setUserListOption(responseUserData?.data?.data)
      }
    }

  useEffect(()=>{
    const getPOIVerificationData = async()=>{
      if(InvestmentCyles.length <1){
        return;
      }
      let reqObj={
        CurrentUserId: Number(userId),
        CurrentCycleId: verifierCycle == null ? Number(InvestmentCyles.find((ic)=>ic.isCurrentCycle == true)?.value) : Number(verifierCycle)
      }
      
      let responsePOIVerificationData = await API.post(fetchVerificationData,reqObj)
      
      if(responsePOIVerificationData?.data?.data){
        const verficaionDashboardData : POIVerificationDataType[] = responsePOIVerificationData?.data?.data.map((item:any)=>({
          Role:item.roleName,
          Name:item.fullName,
          TotalAssigned:item.totalAssigned,
          TotalAccepted:item.totalAccepted,
          TotalRejected:item.totalRejected,
          TotalPartiallyAccepted:item.totalPartiallyAccepted,
          TotalPendingVerification:item.totalPendingVerification
        }))

        setVerificationDashboardData(verficaionDashboardData)
      }
    } 
    getPOIVerificationData()
  },[InvestmentCyles,verifierCycle])

  
  useEffect(()=>{

     let dummy = (Array.isArray(currentuserroleList) ? currentuserroleList : []).map((role: any) => role.Id);
     setUsrRoleList(dummy);
     
  },[currentuserroleList])

  

  const pieChart = {
    height:200,
    data: POIDeclarationData.length > 0
      ? [
        {
          type: 'Submitted',
          value: ((POIDeclarationData[0]?.SubmittedDeclaration ?? 0) / (POIDeclarationData[0]?.TotalEmployeeCount ?? 1)) * 100
        },
        {
          type: 'Not Submitted',
          value: ((POIDeclarationData[0]?.NotSubmittedDeclaration ?? 0) / (POIDeclarationData[0]?.TotalEmployeeCount ?? 1)) * 100
        }
      ]
      : [], // Empty array initially to prevent errors

    angleField: 'value',
    colorField: 'type',
    radius: 0.5,
    appendPadding: 10,
    // innerRadius: 0.4, 
    label: {
      text: ({ value }: { value: number }) => value ? `${value.toFixed(4)}%` : "0%", // Ensure value exists before formatting
      position: 'outside',
    },
    //legend: false
    legend: {
      color: {
        title: true,
        position: 'bottom',
        rowPadding: 0,
      },
    },
    tooltip:({type,value})=>{
      return{type,value};
    },
    interaction: {
      tooltip: {
        render: (e, { items }) => {
          return (
            <React.Fragment>
              {items.map((item) => {
                const { type, value, color } = item;
                return (
                  <div key={type} style={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                      <span
                        style={{
                          display: 'inline-block',
                          width: 6,
                          height: 6,
                          borderRadius: '50%',
                          backgroundColor: color,
                          marginRight: 6,
                        }}
                      ></span>
                      <span style={{padding:5}}>{type}</span>
                    </div>
                    <b>{value ? `${value.toFixed(4)}%`: '0%'}</b>
                  </div>
                );
              })}
            </React.Fragment>
          );
        },
      },
    },
  };

  useEffect(() => {
    if (POISubmissionData.length === 0) return;
    addGraphData();
  }, [POISubmissionData,currentGraphIndex]);


  const addGraphData = () => {
    if (POISubmissionData.length === 0) return;
    let currenIndex = currentGraphIndex == null ? InvestmentCyles.findIndex((data:any)=>data.isCurrentCycle == true) : InvestmentCyles.findIndex((data:any)=>data.value == currentGraphIndex )
    
    const chartData = [
      { category: 'Employee', count: POISubmissionData[currenIndex]?.TotalEmployeeCount, type: 'Total Employees' },
      { category: 'Submission', count: POISubmissionData[currenIndex]?.Submitted, type: 'Submitted' },
      { category: 'Submission', count: POISubmissionData[currenIndex]?.NotSubmitted, type: 'Not Submitted' },
      { category: 'Status', count: POISubmissionData[currenIndex]?.Accepted, type: 'Accepted' },
      { category: 'Status', count: POISubmissionData[currenIndex]?.Rejected, type: 'Rejected' },
      { category: 'Status', count: POISubmissionData[currenIndex]?.PartiallyAccepted, type: 'Partially Accepted' },
      { category: 'Status', count: POISubmissionData[currenIndex]?.PendingVerification, type: 'Pending Verification' },
      { category: 'Unassigned', count: POISubmissionData[currenIndex]?.Unassigned, type: 'Unassigned' }
    ];
  
    const grouped = chartData.reduce((acc: Record<string, typeof chartData>, item) => {
      const key = item.category;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});
  
    const annotations = Object.entries(grouped).map(([key, values]) => {
      const total = values.reduce((sum, item) => sum + item.count, 0);
      return {
        type: 'text',
        data: [{ category: key, count: total }],
        xField: 'category',
        yField: 'count',
        style: {
          text: `${total}`,
          textAlign: 'center',
          textBaseline: 'bottom',
          fontSize: 14,
          fill: 'red',
        },
        tooltip: false,
      };
    });
  
    const config = {
      height: 240,
      data: chartData,
      xField: 'category',
      yField: 'count',
      stack: true,
      colorField: 'type',
      label:false,
      //annotations,
    };
  
    setColumnChart(config); // ✅ This triggers a re-render
  };


  const handleSelectOption =async(type:string,value:any)=>{
    switch (type) {
      case "cycle":
        setCurrentGraphIndex(value)
        break;
      case "user":
        setUserError("")
        setVerifierStaus(null)
        setSelectedUser(value)
        break;
      case "verifierCycle":
        setVerifierCycle(value)
        break;
      case "count":
        setCountError("")
        setCounterStatus(null)
        setCount(value)
      default:
        break;
    }
  }

  const handleAssignClick = async() => {
      showLoader();
      if(!selectedUser){
        setVerifierStaus('error')
        setUserError("Select a verifier");
        hideLoader();
      }
      
      if(!count || Number(count) <= 0){
        setCounterStatus('error')
        setCountError(count<=0 ? "Enter a valid count" :"Count is required");
       // setCountError("Count must be greater than 0");
        //message.error("Count must be greater than 0.");
      }

      
      if (!selectedUser || !count || Number(count) <= 0) {
        hideLoader();
        return;
      }

      let reqObj = {
        CurrentCycleId:Number(InvestmentCyles.find(cycle => cycle.isCurrentCycle == true)?.value),
        PendingWithUserId:Number(selectedUser),
        CurrentUserId:Number(userId),
        Count:Number(count)
      } 
      let responseAssign = await API.post(assignPoiVerification, reqObj)
    
      if(responseAssign.data.data){
        
        if(responseAssign.data.data[0].errorMessage != "" ){
          
          if(responseAssign.data.data[0].errorMessage == "Assigned successfully."){
            hideLoader();
             let selectdUser = userListOption && userListOption.find((userlist)=> selectedUser == userlist?.id)?.name;
            message.success(` ${count} submission have been successfully assigned to ${selectdUser} for verification. `)
            setSelectedUser(null)
            setCount(null)
            getPOIDeclarationData();
          }
          if(responseAssign.data.data[0].errorMessage == "Insufficient unassigned submissions available." ){
            hideLoader();
            //setSelectedUser(null)
            //setCount(null)
            message.error(responseAssign.data.data[0].errorMessage)
          }
         
        }
      }
  }

  return (
    <div className="container-fluid">
      {/* POI Declaration Section */}
      <div className="row">
        <div className="col-lg-12">
          <div className="pageName">
            <Title level={4}>POI Declaration</Title>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-9">
              <FormTable
                columns={POIDeclarationColumns}
                dataSource={POIDeclarationData}
                pagination={false}
              />
            </div>
            <div className="col-lg-3">
              <div className="piechart w-100">
                <Pie {...pieChart} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* POI Submission Section  */}
    <div className="row mt-4">
      <div className="col-lg-12">
        <div className="pageName">
        <Title level={4}>POI Submission</Title>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="row">
          <div className="col-lg-9">
           <FormTable 
            columns={POISubmissionColumns}
            dataSource={POISubmissionData}
            pagination={false}
           />
          </div>
          <div className="col-lg-3">
            <div>
            <Select
              style={{ width: 282 }}
              value={InvestmentCyles && ( currentGraphIndex == null ? InvestmentCyles?.find(c => c?.isCurrentCycle == true)?.value : InvestmentCyles?.find(c => c?.value == currentGraphIndex )?.value )}
              onChange={(value) => handleSelectOption("cycle",value)}
              options={
                InvestmentCyles &&
                InvestmentCyles.map((currentdata:any)=>({
                    value:currentdata?.value,
                    label:currentdata?.label
                })
                )
              }
            />


            </div>
            <div className="columnchart w-100">
              {columnChart && <Column {...columnChart} />}
            </div>
          </div>
        </div>
      </div>
    </div>

      {/* Assign Verification Section */}
      {[1, 2].some(role => usrRoleListArr?.includes(role))  &&
      <div className="row mt-4">
      <div className="col-lg-12">
        <div className='pageName'>
          <Title level={4}>Assign Verification</Title>
        </div>
       <div className="col-lg-12">
            <div className='row'>
              <div className='col-lg-3'>
                <Select 
                  style={{width:widthPercentage}}
                  disabled={true}
                  value={InvestmentCyles && InvestmentCyles.find(cycle => cycle.isCurrentCycle == true)?.value}
                  options={
                    InvestmentCyles &&
                    InvestmentCyles.map((currentdata:any)=>({
                        value:currentdata?.value,
                        label:currentdata?.label
                    })
                    )
                  }
                />
              </div>

              <div className='col-lg-3'>
              <Select 
                  showSearch
                  status={VerifierStaus}
                  placeholder="select verifier"
                  style={{width:widthPercentage}}
                  filterOption={(input,userListOption)=>
                  (userListOption?.label ?? '').toLowerCase().replace(/\s/g,'').includes(input.toLocaleLowerCase().replace(/\s/g,''))
                  }
                  onChange={(value)=> handleSelectOption("user",value)}
                  value={selectedUser}
                  options={
                    userListOption &&
                    userListOption.map((currentdata:any)=>({
                        value:currentdata?.id,
                        label:currentdata?.name
                    })
                    )
                  }
                />
                {userError && <div style={{ color: "red", fontSize: "14px" }}>{userError}</div>}
              </div>

              <div className='col-lg-1'>
                <InputNumber 
                 className="custom-placeholder"
                  value={count}
                  min={0}
                  status={counterStatus}
                  onChange={(value:any)=> handleSelectOption("count",value)}
                  placeholder='Enter Count'
                />
                {countError && <div style={{ color: "red", fontSize: "14px" }}>{countError}</div>}
              </div>

              <div className='col-lg-1'>
                <Button
                  className="btn-submit"
                  type="primary"
                  onClick={()=>handleAssignClick()}
                >
                  Assign
                </Button>
              </div>

              <div className='col-lg-4'>
                <Button
                  className="btn-submit"
                  type="primary"
                  onClick={()=>navigate("/EmployeeRecord")}
                >
                  Start Verifying
                </Button>
              </div>

            </div>
       </div>
      </div>
    </div>
      }

      {/* POI Verifier Status Section */}
    <div className="row mt-4">
      <div className="col-lg-12">
        <div className='pageName'>
        <Title level={4}>POI Verifier Status</Title>
        </div>
      </div>
      <div className="col-lg-12">
        <div className='col-lg-12 d-flex justify-content-end'>
          <div className='col-lg-2'>
          <Select
              style={{ width: 200 }}
              value={InvestmentCyles && ( verifierCycle == null ? InvestmentCyles?.find(c => c?.isCurrentCycle == true)?.value : InvestmentCyles?.find(c => c?.value == verifierCycle )?.value )}
              onChange={(value) => handleSelectOption("verifierCycle",value)}
              options={
                InvestmentCyles &&
                InvestmentCyles.map((currentdata:any)=>({
                    value:currentdata?.value,
                    label:currentdata?.label
                })
                )
              }
            />
          </div>
        </div>
        <div>
        <FormTable 
          columns={POIVerifierStatusColumn}
          dataSource={POIVerificationDashBoardData} 
          pagination={false}
        />
        </div>  
      </div>
    </div>
    </div>

  )
}

export default VerificationPOI;